import React from 'react';

import {
  ANALYTICS_PAGE_NAMES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import { POSSESSIVE_ADJECTIVES } from 'dpl/breeder_dashboard_v2/utils/constants';
import { breederPostsQueryDefinition } from 'dpl/breeder_posts/utils/resourceDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import BreederPostCardsCarousel from 'dpl/breeder_posts/components/BreederPostCardsCarousel';
import LoadingSpinner from 'dpl/components/LoadingSpinner';
import SectionViewTracker from 'dpl/common/components/SectionViewTracker';

import Section from './Section';
import { usePuppyData } from '../hooks/usePuppyData';

export default function LitterUpdates() {
  const { breeder, litter, puppy } = usePuppyData();

  const {
    isLoading,
    refetch,
    value: { data: breederPosts }
  } = useResourceQuery(
    breederPostsQueryDefinition(breeder.id, { litter_id: litter.id })
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (breederPosts.length === 0) {
    return null;
  }

  const possessiveAdjective =
    POSSESSIVE_ADJECTIVES[puppy.gender?.toLowerCase()] || 'their';

  return (
    <SectionViewTracker
      name={ANALYTICS_PAGE_NAMES.PUPPY_PROFILE}
      category="puppy-profile-updates"
    >
      <section className="LitterUpdates pt12 pt20-md font-16 overflow-hidden">
        <div className="container-xxl">
          <Section.Heading>
            Updates on {puppy.name}&apos;s litter
          </Section.Heading>
          <Section.Subheading className="mt2 mt4-md">
            Get a behind-the-scenes look at how {breeder.first_name} raises{' '}
            {puppy.name} and {possessiveAdjective} siblings as they grow.
          </Section.Subheading>

          <BreederPostCardsCarousel
            analytics={{
              view: ANALYTICS_VIEWS.PUPPY_PROFILE,
              view_feature_location:
                ANALYTICS_VIEW_FEATURE_LOCATIONS.UPDATES_SECTION
            }}
            className="mt10 mt16-md"
            breederPosts={breederPosts}
            refetchBreederPosts={refetch}
          />
        </div>
      </section>
    </SectionViewTracker>
  );
}
